import { useCallback } from "react";

import { getUserIdSync } from "src/config/storage";
import { useSalesTransactionsDataLoaderContext } from "src/utils/userData/SalesTransactionsDataLoaderContext";
import type { ExtendManualLoadedFromDateParams } from "src/utils/userData/DataLoaderManager";

export type SetManualLoadedFromDateOptions = Pick<
  ExtendManualLoadedFromDateParams,
  "onBeforeFirestoreWait"
>;

/**
 * When a report needs data older than what is already covered by the effective
 * loaded-from date, delegates to `DataLoaderManager.extendManualLoadedFromDate`.
 */
export function useSetManualLoadedFromDate(): (
  startDate?: Date | null,
  options?: SetManualLoadedFromDateOptions
) => Promise<void> {
  const { getManager } = useSalesTransactionsDataLoaderContext();

  return useCallback(
    async (
      startDate?: Date | null,
      options?: SetManualLoadedFromDateOptions
    ) => {
      const manager = getManager();
      if (!manager) {
        console.warn(
          "SalesTransactionsDataLoaderProvider is not mounted; skipping manual sales/tx window expansion."
        );
        return;
      }

      const userId = getUserIdSync().trim();
      await manager.extendManualLoadedFromDate({
        userId,
        startDate,
        onBeforeFirestoreWait: options?.onBeforeFirestoreWait,
      });
    },
    [getManager]
  );
}
